<template>
  <div class="tags mb-0 tags--deal">
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:blackweek21') && $whitelabel.campaignsEnabled" type="is-dark" class="is-family-sans-serif">Black Week Deal</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:valentin22') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">Valentins-Tipp</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:ostern21') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">Oster-Tipp</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:muttertag21') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">Muttertags-Tipp</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:ssv2021') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">SSV</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:xmas21') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">X-Mas Deal</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:deal') && $whitelabel.campaignsEnabled && $whitelabel.short === 'ooesb'" type="is-primary" class="is-family-sans-serif">Reiseschnäppchen</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:deal') && $whitelabel.campaignsEnabled && $whitelabel.short === 'Urlaubsguru'" type="is-primary" class="is-family-sans-serif">Top Angebot</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:deal') && $whitelabel.campaignsEnabled && $whitelabel.short === 'sbscom'" type="is-primary" class="is-family-sans-serif">Deal</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:chalet') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">Chalet</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:city') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">City</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:wellness') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">Wellness</b-tag>
    <b-tag v-if="$options.filters.haspromotion(offer, 'Custom:wien') && $whitelabel.campaignsEnabled" type="is-primary" class="is-family-sans-serif">Wien-Deal</b-tag>
    <b-tag v-if="hasTraveldealTag" type="is-primary" class="is-family-sans-serif">Travel Deal</b-tag>
  </div>
</template>

<script>
export default {
  name: 'OfferTags',
  props: {
    offer: Object,
  },
  data() {
    return {
      hasTraveldealTag: false,
    }
  },
  mounted() {
    this.hasTraveldealTag =
      this.$whitelabel.campaignsEnabled &&
      (this.$options.filters.haspromotion(this.offer, 'Custom:italia') ||
        this.$options.filters.haspromotion(this.offer, 'Custom:watitalia') ||
        this.$options.filters.haspromotion(this.offer, 'Custom:de22') ||
        this.$options.filters.haspromotion(this.offer, 'Custom:gardasee') ||
        this.$options.filters.haspromotion(this.offer, 'Custom:suedtirol'))
  },
}
</script>

<style scoped lang="scss">
.tags--deal {
  .tag {
    margin-bottom: 0;
  }
}
</style>
